import HouseEN from 'oldAssets/images/static_pages/property_transaction_process/house_en.svg';
import HouseDE from 'oldAssets/images/static_pages/property_transaction_process/house_de.svg';

import WA from "oldAssets/images/icons/wa-icon.png";
import Bank from 'oldAssets/images/static_pages/property_transaction_process/bank.svg';
import Natar from 'oldAssets/images/static_pages/property_transaction_process/paragraph.svg';
import Buyer from 'oldAssets/images/static_pages/property_transaction_process/person.svg';
import Seller from 'oldAssets/images/static_pages/property_transaction_process/business-agent.svg';
import Contract from 'oldAssets/images/static_pages/property_transaction_process/contract.svg';

const house = (locale) => locale == 'en' ? HouseEN : HouseDE;

const icons = {
  wa: WA,
  buyers: Buyer,
  sellers: Seller,
  natar: Natar,
  bank: Bank,
  selected: Contract
};

const getIcons = (names, legend) => {
  return names.map(name => {
    return {
      name,
      src: icons[name],
      title: legend[name]
    };
  }).filter(icon => icon.src);
}

export { house, icons, getIcons };
